import React from 'react';
import { ToastWrapperStyled } from './styled';
import { ToastNotification } from '@volkswagen-onehub/components-core';
import { useToast } from '../../context/ToastContext';

const Toast = () => {
  const { toast, toastMessage, toastAppearance, hideToast } = useToast();

  return (
    <ToastWrapperStyled>
      <ToastNotification
        show={toast}
        title={toastMessage}
        appearance={toastAppearance}
        onClose={hideToast}
        fadeIn
      />
    </ToastWrapperStyled>
  );
};

export default Toast;
